module.exports = __webpack_public_path__ + "img/document-75.ad0726f2.svg";